import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import Icon from '../../components/AppIcon';

const TermsOfService = () => {
  const { t } = useTranslation();
  const intro = t('legal.terms.intro', { returnObjects: true });
  const sections = t('legal.terms.sections', { returnObjects: true });
  const introParagraphs = Array.isArray(intro) ? intro : [];
  const [parties, ...notes] = introParagraphs;
  const sectionList = Array.isArray(sections) ? sections : [];

  return (
    <>
      <Helmet>
        <title>{t('legal.terms.title')} - HirePortal</title>
        <meta name="description" content={t('legal.terms.metaDescription')} />
      </Helmet>
      <div className="min-h-screen bg-white text-foreground">
        <div className="border-b border-border bg-[#f7f8fb]">
          <div className="mx-auto max-w-3xl px-5 py-10 md:py-16">
            <Link
              to="/authentication"
              className="mb-8 inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground"
            >
              <Icon name="ArrowLeft" size={16} />
              {t('legal.back')}
            </Link>

            <p className="text-xs font-semibold uppercase tracking-widest text-primary">
              {t('legal.terms.kicker')}
            </p>
            <h1 className="mt-3 text-3xl font-semibold tracking-tight text-foreground sm:text-4xl">
              {t('legal.terms.title')}
            </h1>
            <p className="mt-3 text-sm text-muted-foreground">
              {t('legal.terms.version')}
            </p>
            {parties ? (
              <p className="mt-6 text-sm leading-relaxed text-muted-foreground">
                {parties}
              </p>
            ) : null}
          </div>
        </div>

        <div className="mx-auto max-w-3xl px-5 py-14">
          {notes.map((note) => (
            <div
              key={note}
              className="flex gap-3 rounded-2xl border border-amber-300/70 bg-amber-50 p-4 text-amber-950"
            >
              <Icon name="TriangleAlert" size={16} className="mt-0.5 shrink-0" />
              <p className="text-xs leading-relaxed">{note}</p>
            </div>
          ))}

          <div className="mt-10 space-y-9">
            {sectionList.map((section) => (
              <section key={section.title}>
                <h2 className="text-lg font-semibold tracking-tight text-foreground">
                  {section.title}
                </h2>
                {(section.paragraphs ?? []).map((paragraph) => (
                  <p key={paragraph} className="mt-3 text-sm leading-relaxed text-muted-foreground">
                    {paragraph}
                  </p>
                ))}
                {section.bullets?.length ? (
                  <ul className="mt-3 space-y-2">
                    {section.bullets.map((item) => (
                      <li key={item} className="flex gap-2.5 text-sm leading-relaxed text-muted-foreground">
                        <span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-primary" aria-hidden="true" />
                        <span>{item}</span>
                      </li>
                    ))}
                  </ul>
                ) : null}
              </section>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default TermsOfService;
